import { createSelector } from 'reselect';

import getIsLoading from '~/src/packages/bp42/selectors/getIsLoading';
import getPackageName from '~/src/packages/bp42/selectors/getPackageName';
import getProducts from '~/src/packages/bp42/selectors/getProducts';
import getStartedTyping from '~/src/packages/bp42/selectors/getStartedTyping';
import getViewDetails from '~/src/packages/bp42/selectors/getViewDetails';
import isFormValid from '~/src/packages/bp42/selectors/isFormValid';
import isNeedToShowSpecOffer from '~/src/packages/bp42/selectors/isNeedToShowSpecOffer';

const selectDataForCallbackForm = createSelector(
    [
        getProducts,
        getPackageName,
        getViewDetails,
        isNeedToShowSpecOffer,
        getStartedTyping,
        isFormValid,
        getIsLoading,
    ], (
        products,
        packageName,
        viewDetails,
        needToShowSpecOffer,
        isStartedTyping,
        formValid,
        isLoading,
    ) => ({
        packageName,
        products,
        viewDetails,
        needToShowSpecOffer,
        isStartedTyping,
        isFormValid: formValid,
        isLoading,
    }),
);

export default selectDataForCallbackForm;
